const env = {
  baseUrl: "https://staging-api.utirx.com/backend/",
};

export default env;
